var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.451 16.162a2.445 2.445 0 0 1-2.448-2.45v-.995h-1.004a2.45 2.45 0 0 1-2.449-2.448c0-.286.057-.564.147-.817H8.771A3.77 3.77 0 0 0 5 13.215v21.588a3.77 3.77 0 0 0 3.77 3.763h3.763v7.427c0 .327.196.629.507.751.097.04.204.065.31.065a.836.836 0 0 0 .58-.236l7.998-8.007h14.569a3.77 3.77 0 0 0 3.77-3.763V16.015a2.49 2.49 0 0 1-.816.146zM13.35 18.928h8.063c.45 0 .817.36.817.816a.819.819 0 0 1-.817.817H13.35a.819.819 0 0 1-.817-.817c0-.456.368-.816.817-.816zM31.918 29.09H13.35a.819.819 0 0 1-.817-.816c0-.45.368-.817.817-.817h18.568c.449 0 .816.368.816.817a.819.819 0 0 1-.816.816zM42.904 9.452h-2.637V6.816A.819.819 0 0 0 39.451 6a.819.819 0 0 0-.816.816v2.636H36a.819.819 0 0 0-.816.817c0 .449.367.816.816.816h2.636v2.636c0 .449.367.816.816.816a.819.819 0 0 0 .816-.816v-2.636h2.637a.819.819 0 0 0 .816-.816.819.819 0 0 0-.816-.817z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyIcon3);
export default __webpack_public_path__ + "static/media/warrantyIcon3.be74f7537df832976dc74646a1404146.svg";
export { ForwardRef as ReactComponent };